import { useQuery } from '@tanstack/react-query'

import { request } from '../../../lib/axios'
import { ExtractFnReturnType, QueryConfig } from 'Lib/react-query'
import { useUserStore } from 'Stores/userStoreModuleFed'

import { AudienceTagSelection } from '../MicrosoftAudienceModal.utils'

export const getMicrosoftAudiences = async (
  accountId: number
): Promise<{ audiences: AudienceTagSelection[] } | Error> => {
  return await request<{ audiences: AudienceTagSelection[] }>({
    url: `/accounts/${accountId}/audiences/bing`,
    method: 'GET',
  })
}

type QueryFnType = typeof getMicrosoftAudiences

export const useGetMicrosoftAudiences = (config: QueryConfig<QueryFnType>) => {
  const { accountId } = useUserStore()
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['microsoftAudiencesData', accountId],
    queryFn: () => getMicrosoftAudiences(accountId),
    staleTime: 0,
    ...config,
  })
}
